// 会议管理接口
export default {
    // 添加会议
    addMeeting:'/crMeetingInfo/add',
    // 添加轮播图
    addCarouse:'/crMeetingInfo/addCarouse',
    updateCarouse:'/crMeetingInfo/updateCarouse',
    deleteCarouse:'/crMeetingInfo/deleteCarouse',
    updateCarouseMaRandNum:'/crMeetingInfo/updateCarouseMaRandNum',
    // 获取轮播图列表
    getCarouseList:'/crMeetingInfo/carouselMapList',
    // 删除会议
    deleteMeeting:'/crMeetingInfo/delete',
    // 编辑会议
    editMeeting:'/crMeetingInfo/edit',
    // 获取会议详情
    getMeetingDetail:'/crMeetingInfo/getDetails',
    // 获取会议列表
    getMeetingList:'/crMeetingInfo/getList',
    // 搜索会议
    searchMeeting:'/crMeetingInfo/search',

    // 添加会议介绍
    addIntroduction:'/crConference/addIntroduction',
    // 查询会议介绍
    requestIntroduction:'/crConference/getSerchConferenceIntroduction',
    //编辑会议介绍
    editIntroduction:'/crConference/getUpdateConferenceIntroduction',

    //重要日期相关添加
    //title标题      titleEn英文标题meetingCode   startTime开始时间      endTime    结束时间
    addCrConference:'/crConference/add',
    updateCrConference:'/crConference/update',
    deleteCrConference:'/crConference/delete',
    getListCrConference:'/crConference/importantInfoList',
    //排序
    updateImportRandNum:'/crConference/updateImportRandNum',
    //会议排序
    updateMeetingRandNum:'/crMeetingInfo/updateMeetingRandNum',

    //会议日程
    addSchedule:'/crConference/addSchedule',
    updateSchedule:'/crConference/updateSchedule',
    searchSchedule:'/crConference/searchSchedule',

    //其他信息
    addOther:'/crConference/addOther',
    updateOther:'/crConference/updateOther',
    searchOther:'/crConference/searchOther',

    //发起单位
    searchSponsor:'/crMeetingInfo/searchSponsor',
    updateSponsor:'/crMeetingInfo/updateSponsor',
    addSponsor:'/crMeetingInfo/addSponsor',

    //设置是否公开
    isItOpen:'/crMeetingInfo/isItOpen',
    isItNotOpen:'/crMeetingInfo/isItOpen1',
    //查询是否公开
    searchIsItOpen:'/crMeetingInfo/searchIsItOpen',

    //主题色
    //查询
    requestThemeMessage:'/crMeetingTheme/themeMessage',
    setThemeSetup:'/crMeetingTheme/themeSetup',

    // 会议列表 (所有公开的会议)
    getAllOpenMeetingList: '/crMeetingInfo/menuList',
    // 提交论文  搜索作者
    searchDocAuthor: '/crDocAuthor/search',

    // 访问日志列表
    viewLog: '/crMeetingInfo/viewDataList',

    // 访问日志详细导出
    viewLogExport: '/crMeetingInfo/viewDataExport',

    //所有公开的会议列表
    openList: 'crMeetingInfo/openList'
}
